import selections from '@/store/actions/selections.ts'
import presentation from '@/store/actions/presentation.ts'
import questions from '@/store/actions/questions.ts'

export default {
  ...presentation,
  ...selections,
  ...questions,
}
